module.exports = __webpack_public_path__ + "img/pr.31f55200.svg";